import { ALARM_DETAIL_ROUTE, PATHS } from '@ctcells/core'
import type { RouteObject } from 'react-router'

import {
  AlarmsSplitRoute,
  BatchesSplitRoute,
  HistorySplitRoute,
  MonitoringRoute,
  NewBatchModalRoute,
} from './consoleOpsViews.tsx'

/**
 * 콘솔 「운영」 그룹 라우트 조각. **쵸단 담당 파일이다.**
 *
 * `apps/console/src/routes.tsx` 가 이 배열을 그대로 펼쳐 넣으므로 앱 라우트 파일을 건드리지 않는다.
 *
 * 이동을 끼우는 얇은 어댑터 컴포넌트는 `consoleOpsViews.tsx` 에 있다 —
 * 한 파일이 컴포넌트만 내보내야 핫리로드가 성립해서 표와 컴포넌트를 갈라 두었다.
 * 화면 자체는 라우터를 모른다.
 */
export const consoleOpsRoutes: RouteObject[] = [
  { path: PATHS.monitoring, element: <MonitoringRoute /> },
  { path: `${PATHS.monitoring}/:moduleKey`, element: <MonitoringRoute /> },
  /* 시료 카드 → 오른쪽 상세 판(eric 2026-09-27). 넘어가지 않는다 — 모니터링이 왼쪽에 그대로 선다 */
  { path: `${PATHS.monitoring}/sample/:sampleId`, element: <MonitoringRoute /> },
  { path: `${PATHS.monitoring}/:moduleKey/sample/:sampleId`, element: <MonitoringRoute /> },
  /* 소모품 요약 칩 → 본문 오른쪽 열에 겹쳐 뜨는 판(eric 2026-09-27 · 2026-09-29 「영역이 일정하게」). 주소가 판의 열림 상태다 */
  { path: `${PATHS.monitoring}/supply/:supplyKey`, element: <MonitoringRoute /> },
  { path: `${PATHS.monitoring}/:moduleKey/supply/:supplyKey`, element: <MonitoringRoute /> },

  /* 목록 + 오른쪽 상세 판 — 두 주소가 같은 화면이다. `:batchId` 가 있으면 판이 열린다(eric 2026-09-22) */
  { path: PATHS.batches, element: <BatchesSplitRoute /> },
  /* 새 작업은 목록 위의 창이다(eric 2026-09-22). 페이지로 되돌리려면 `NewBatchRoute` */
  { path: PATHS.batchNew, element: <NewBatchModalRoute /> },
  { path: `${PATHS.batches}/:batchId`, element: <BatchesSplitRoute /> },

  /* 이력도 같은 서랍이다(eric 2026-09-22 「작업의 이력도 이와 같이」) */
  { path: PATHS.batchHistory, element: <HistorySplitRoute /> },
  { path: `${PATHS.batchHistory}/:batchId`, element: <HistorySplitRoute /> },

  /*
   * access·데이터는 컨테이너가 넣는다(화면은 무수정).
   * 🔴 **`opsTab` 을 안 넘긴다**(2026-09-22 eric 지시 「작업에서 알람탭을 따로 떼줘」). 알람은
   *    헤더의 제 문이라 무리에 속하지 않는다 — 넘길 탭이 아예 없어졌다.
   */
  { path: PATHS.alarms, element: <AlarmsSplitRoute /> },
  /* 알람도 같은 서랍이다(eric 2026-09-28 「알람에서도 구조를 오른쪽으로.. 상세 페이지 보이게」) */
  { path: ALARM_DETAIL_ROUTE, element: <AlarmsSplitRoute /> },
]
